export function initAdminUserListSearchForm(): void {
  const searchForm = window.config.pageData.adminUserListSearchForm;
  if (!searchForm) return;

  const form = document.querySelector<HTMLFormElement>('#user-list-search-form');
  if (!form) return;

  for (const button of form.querySelectorAll(`button[name=sort][value="${CSS.escape(searchForm.SortType)}"]`)) {
    button.classList.add('active');
  }

  if (searchForm.StatusFilterMap) {
    for (const [k, v] of Object.entries(searchForm.StatusFilterMap)) {
      if (!v) continue;
      for (const input of form.querySelectorAll<HTMLInputElement>(`input[name="status_filter[${CSS.escape(k)}]"][value="${CSS.escape(v)}"]`)) {
        input.checked = true;
      }
    }
  }

  for (const radio of form.querySelectorAll<HTMLInputElement>('input[type=radio]')) {
    radio.addEventListener('click', () => {
      form.submit();
    });
  }

  const resetButtons = form.querySelectorAll<HTMLAnchorElement>('.j-reset-status-filter');
  for (const button of resetButtons) {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      for (const input of form.querySelectorAll<HTMLInputElement>('input[type=radio]')) {
        if (input.name.startsWith('status_filter[')) {
          input.checked = false;
        }
      }
      form.submit();
    });
  }
}
export function initAdminUserList(): void {
  const user = document.querySelector<HTMLDivElement>('.admin.user .admin-setting-content');
  if (!user) return;

  const btnDel = document.querySelectorAll('[id^="_admin_user_opt_"]');
  if (btnDel.length === 0) return;

  const checkboxes = user.querySelectorAll<HTMLInputElement>('.table td input[type=checkbox]');
  const dlgs = document.querySelectorAll('[id^="users_list_opt_"]');

  for (const checkbox of checkboxes) {
    checkbox.addEventListener('change', () => {
      let anyChecked = false;

      if (dlgs.length > 0) {
        for (const dlg of dlgs) {
          dlg.innerHTML = '';
        }

        for (const checkbox1 of checkboxes) {
          if (checkbox1.checked) {
            for (const dlg of dlgs) {
              const input = document.createElement('input');
              input.type = 'hidden';
              input.name = 'id';
              input.value = checkbox1.getAttribute('data-bind') || '';
              dlg.append(input);
            }
            anyChecked = true;
          }
        }
      }

      for (const btn of btnDel) {
        (btn as HTMLElement).style.display = anyChecked ? 'block' : 'none';
      }
    });
  }
}
